import React, { useState } from "react";
import { BsPlusLg } from "react-icons/bs";
import TextInputTag from "./TextInputTag";

const TextAreaInput = ({ item }) => {
  const {
    label,
    name,
    type,
    defaultValue,
    multiple,
    multipleData,
    required,
    fullCol,
    placeholder,
  } = item;

  const [quantityCount, setCount] = useState(multipleData);
  const handleAddElement = () => {
    setCount((current) => [
      ...current,
      {
        label: label,
        type: type,
        name: "",
        defaultValue: "",
      },
    ]);
  };
  return (
    <div
      className={`${
        fullCol ? "col-span-3" : "col-span-3 md:col-span-2 lg:col-span-1"
      } flex flex-row gap-4 items-centers w-full fitHeight`}
    >
      <div className="col-span-2 w-full ">
        {multipleData ? (
          quantityCount.map((item, index) => (
            <TextInputTag
              key={index}
              label={label}
              length={index + 1}
              name={name}
              defaultValue={item.defaultValue}
              multiple={multiple}
              required={required}
              placeholder={placeholder}
            />
          ))
        ) : (
          <TextInputTag
            label={label}
            length={0}
            name={name}
            defaultValue={defaultValue}
            multiple={multiple}
            required={required}
            placeholder={placeholder}
          />
        )}
      </div>

      {multiple && (
        <div
          className={`${
            quantityCount.length > 0 ? "-mt-16" : "mt-16"
          } flex justify-start w-full items-end`}
        >
          <div
            onClick={handleAddElement}
            className="flex gap-2 border rounded-full border-gray-800 py-1 px-4 pr-1"
          >
            <label className="label cursor-pointer">
              <span className="text-base font-semibold whitespace-nowrap">
                Add {label}
              </span>
            </label>
            <button
              onClick={handleAddElement}
              type="button"
              className="btn btn-circle"
            >
              <BsPlusLg />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TextAreaInput;
